/* Javascript to show and hide cookie banner using localstorage */
/* Shows the Cookie banner */
function showCookieBanner(){
 let cookieBanner = document.getElementById("cookie-bar");
 cookieBanner.style.display = "block";
}

/* Hides the Cookie banner and saves the value to localstorage */
function hideCookieBanner(){
 localStorage.setItem("isCookieAccepted", "yes");
 let cookieBanner = document.getElementById("cookie-bar");
 cookieBanner.style.display = "none";
}

/* Checks the localstorage and shows Cookie banner based on it. */
function initializeCookieBanner(){
 let isCookieAccepted = localStorage.getItem("isCookieAccepted");
 if(isCookieAccepted === null)
 {
  localStorage.setItem("isCookieAccepted", "no");
  showCookieBanner();
 }
 if(isCookieAccepted === "no"){
  showCookieBanner();
 }
}

// Assigning values to window object
document.onload = initializeCookieBanner();
document.hideCookieBanner = hideCookieBanner;